import { Builder } from '@builder.io/sdk';
import { S12ReviewsSection } from '../components/interactive-sections/S12Reviews';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import {
  backgroundColorOptions,
  backgroundGradientOptions,
  textColorOptionsLimited,
} from '../utils/builderColorOptions';
import { getBackgroundGradientInput, getPaddingInputs, getBackgroundColorInput } from '../utils/builderSharedInputs';

Builder.registerComponent(S12ReviewsSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S12Reviews,
  friendlyName: 'S12 Reviews',
  inputs: [
    {
      name: 'headline',
      type: 'string',
      friendlyName: 'Headline',
      required: true,
      defaultValue: 'Don’t just take our word for it!',
      helperText: 'The main heading displayed at the top of the reviews section'
    },
    {
      name: 'headlineColor',
      type: 'string',
      friendlyName: 'Headline Color',
      enum: textColorOptionsLimited,
      defaultValue: 'Blue',
      helperText: 'Select a color for the headline text'
    },
    {
      name: 'reviews',
      friendlyName: 'Reviews',
      type: 'list',
      required: true,
      onChange: (options) => {
        const currentReviews = options.get('reviews');
        const reviewCount = currentReviews.length;

        // Check if less than minimum (but only if they're trying to go below 4)
        if (reviewCount < 4) {
          alert('Minimum 4 reviews required. Please add more reviews.');
        }
      },
      defaultValue: [
        {
          name: 'Ivan H.',
          nameColor: 'Navy',
          reviewText: 'I\'ve had the pleasure of being a loyal client of Milan Laser for nearly a decade, and each visit has consistently exceeded my expectations. The staff\'s warm hospitality and professionalism.',
          reviewTextColor: 'Navy',
          stars: 5
        },
        {
          name: 'Ahmad S.',
          nameColor: 'Navy',
          reviewText: 'I love Milan! Alexis recommended that I start laser hair removal as I hate shaving and waxing and I am so glad I did! I have seen so much reduction in my treated areas.',
          reviewTextColor: 'Navy',
          stars: 5
        },
        {
          name: 'Luke C.',
          nameColor: 'Navy',
          reviewText: 'I decided to get laser hair removal for medical reasons. I have a condition that affects my joints and skin, and small nicks when shaving my armpits had led to painful infections.',
          reviewTextColor: 'Navy',
          stars: 5
        },
        {
          name: 'Ashli B.',
          nameColor: 'Navy',
          reviewText: 'I\'ve only had 4 treatments so far and the results have been amazing! Yes I\'ve had a different nurse each time but each one has been knowledgeable and thorough with my treatment.',
          reviewTextColor: 'Navy',
          stars: 5
        }
      ],
      helperText: 'Add customer reviews with ratings (minimum: 4, maximum: 12). Note: The component displays reviews in groups of 4 cards, so for best visual results, use 4, 8, or 12 reviews.',
      subFields: [
        {
          name: 'name',
          type: 'string',
          friendlyName: 'Customer Name',
          required: true,
          helperText: 'Enter the customer\'s name'
        },
        {
          name: 'nameColor',
          type: 'string',
          friendlyName: 'Name Color',
          enum: textColorOptionsLimited,
          defaultValue: 'Navy',
          helperText: 'Select a color for the customer name'
        },
        {
          name: 'reviewText',
          type: 'string',
          friendlyName: 'Review Text',
          required: true,
          regex: {
            pattern: '^.{1,185}$',
            message: 'Review text must be between 1 and 185 characters'
          },
          helperText: 'Enter the customer review text (maximum 185 characters)'
        },
        {
          name: 'reviewTextColor',
          type: 'string',
          friendlyName: 'Review Text Color',
          enum: textColorOptionsLimited,
          defaultValue: 'Navy',
          helperText: 'Select a color for the review text'
        },
        {
          name: 'stars',
          type: 'number',
          friendlyName: 'Star Rating',
          required: true,
          defaultValue: 5,
          min: 1,
          max: 5,
          helperText: 'Enter the star rating (1-5)'
        }
      ]
    },
    {
      name: 'cardBackgroundColor',
      type: 'string',
      friendlyName: 'Card Background Color',
      enum: backgroundColorOptions,
      defaultValue: 'TrueWhite',
      helperText: 'Select the background color for review cards. Select None if a card background gradient is selected.'
    },
    {
      name: 'cardBackgroundGradient',
      type: 'string',
      friendlyName: 'Card Background Gradient',
      enum: backgroundGradientOptions,
      helperText: 'Select a gradient for the review card backgrounds. Select None if a card background color is selected.'
    },
    {
      name: 'cardBackgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      friendlyName: 'Card Background Image',
      helperText: 'Upload an image to use as the review card background'
    },
    ...getBackgroundColorInput({}),
    ...getBackgroundGradientInput({
      defaultValue: 'BlueTop',
      backgroundGradientList: backgroundGradientOptions,
    }),
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'webp'],
      friendlyName: 'Background Image',
      helperText: 'Upload an image to use as the section background'
    },
    ...getPaddingInputs({
      desktopTop: "large",
      desktopBottom: "large",
      mobileTop: "small",
      mobileBottom: "small"
    }),
  ]
});
